
import React from 'react';

const ServiceDescription: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-wide">
        <div>
          <h2 className="heading-lg text-itmgmt-dark-blue mb-6">Strategic IT Consulting</h2>
          <p className="text-lg text-gray-600 mb-8">
            Our consulting services help businesses make informed technology decisions that 
            align with their strategic goals and drive operational efficiency.
          </p>
          
          <div className="space-y-6">
            <div className="bg-itmgmt-light-gray p-6 rounded-lg">
              <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-3">Consulting Services</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>New Office Setup / Relocation</span>
                </li>
                <li className="flex items-start">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Business Tech Stack Planning</span>
                </li>
                <li className="flex items-start">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Software Recommendations</span>
                </li>
                <li className="flex items-start">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>IT Budgeting & Forecasting</span>
                </li>
                <li className="flex items-start">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Risk & Vulnerability Assessments</span>
                </li>
                <li className="flex items-start">
                  <span className="text-itmgmt-bright-blue mr-2 font-bold">•</span>
                  <span>Technology Roadmap Development</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDescription;
